import { initialPagination, initialState, makeListEffects, makeListReducers } from '@/models/utils';

import { filtersConfig } from './utils';

const namespace = 'teamsMessageTrace';

const TeamsMessageTraceModel = {
  namespace,
  state: {
    ...initialState,
    orderBy: 'created desc',
    filtersConfig,
  },

  effects: {
    ...makeListEffects({
      namespace,
      fetchRoute: 'teamsMessageTrace',
      fetchParams: 'teamsMessageTrace',
    }),
    *openDrawerView({ payload }, { put }) {
      yield put({
        type: 'openDrawerViewReducer',
        payload,
      });
    },
    *closeDrawerView({ payload }, { put }) {
      yield put({
        type: 'closeDrawerViewReducer',
        payload,
      });
    },
  },
  reducers: {
    ...makeListReducers({
      initialPagination,
      initialState: {
        ...initialState,
        filtersConfig,
      },
    }),

    openDrawerViewReducer(state, { payload }) {
      return {
        ...state,
        id: payload.id,
        openView: payload.state,
        item: null,
        view: true,
      };
    },
    closeDrawerViewReducer(state, { payload }) {
      return {
        ...state,
        id: null,
        openView: payload.state,
        item: null,
        view: false,
      };
    },
  },
};

export default TeamsMessageTraceModel;
